import { jsxs as I, jsx as o } from "react/jsx-runtime";
import g from "clsx";
import { ButtonIcon as k } from "../ButtonIcon/ButtonIcon.js";
import { IconXMark as B, IconExclamationMarkCircle as m, IconCheckCircle as C, IconInfoCircle as S } from "../Icons/index.js";
import { alertVariants as c } from "./Alert.variants.js";
import { AlertTitle as w } from "./Title/AlertTitle.js";
import { AlertDescription as y } from "./Description/AlertDescription.js";
const A = {
  informative: /* @__PURE__ */ o(S, { size: "lg" }),
  positive: /* @__PURE__ */ o(C, { size: "lg", variant: "outlined" }),
  notice: /* @__PURE__ */ o(m, { size: "lg" }),
  negative: /* @__PURE__ */ o(m, { size: "lg" })
}, M = c.definition().defaultVariants, i = c, l = ({
  as: a = "div",
  children: d,
  classes: t,
  className: f,
  closeButtonAriaLabel: e,
  hasRoleAlert: p,
  icon: u,
  onClose: n,
  severity: r = M.severity,
  ...v
}) => {
  if (n && !e)
    throw new Error(
      "`closeButtonAriaLabel` must be provided when `onClose` is set."
    );
  const N = i.root({
    severity: r,
    className: g(f, t == null ? void 0 : t.root)
  }), h = i.icon({ severity: r, className: t == null ? void 0 : t.icon }), x = i.content({ className: t == null ? void 0 : t.content }), z = i.closeButton({
    className: t == null ? void 0 : t.closeButton
  });
  return /* @__PURE__ */ I(
    a,
    {
      role: p ? "alert" : void 0,
      className: N,
      ...v,
      children: [
        /* @__PURE__ */ o("div", { className: h, children: u || A[r] }),
        /* @__PURE__ */ o("div", { className: x, children: d }),
        n && /* @__PURE__ */ o(
          k,
          {
            ariaLabel: e,
            className: z,
            onClick: n,
            size: "sm",
            variant: "text",
            children: /* @__PURE__ */ o(B, { size: "md" })
          }
        )
      ]
    }
  );
};
l.Title = w;
l.Description = y;
export {
  l as Alert
};
